import React from 'react'
import PropTypes from 'prop-types'

import { withRouter } from 'react-router'

import Box from '@material-ui/core/Box'
import TabContext from 'contexts/TabContext'

const TabItem = ({
  classes,
  history,
  location,
  staticContext,
  children,
  label,
  index,
  value,
  ...rest
}) => {
  const context = React.useContext(TabContext)

  if (context.state.current !== value) {
    return null
  }

  return (
    <Box
      role="tabpanel"
      name={label}
      {...rest}
    >
      {children}
    </Box>
  )
}

TabItem.propTypes = {
  children: PropTypes.node.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.any.isRequired,
}

export default withRouter(TabItem)
